import { Component } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import * as saveAs from 'file-saver';
import { BehaviorSubject, Observable } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
} from "rxjs/operators";
import { UserService } from "src/app/modules/auth-client/services/user.service";
import { environment } from "src/environments/environment";
import { NotifyService } from "../../../../brover-notify/services/notify.service";
import {
  ArticleFilter,
  ArticlesSearch,
} from "../../../entities/ArticlesSearch";
import { ArticleService } from "../../../services/article.service";
import { CompanyService } from "../../../services/company.service";
import { FilterService } from "../../../services/filter.service";
import { ShoppingService } from "../../../services/shopping.service";
import { SpinnerService } from "../../../services/spinner.service";
import { SaveOrderDialogComponent } from "../save-order-dialog/save-order-dialog.component";

export interface Filter {
  title: string;
  order: number;
  columns: {
    searchProperty: string;
    searchValues: {
      id: number;
      value: string;
      title: string;
      selected: boolean;
    }[];
  }[];
}

@Component({
    selector: "brover-configurate",
    templateUrl: "./configurate.component.html",
    styleUrls: ["./configurate.component.sass"],
    standalone: false
})
export class ConfigurateComponent {
  public brand = null;
  public type = null;
  public filters: Filter[] = [];
  public groupFilter = [];
  private wsaValues: {
    group: string;
    sort: number;
    image: string;
    subgroups: { name: string; sort: number; image: string }[];
    wsaGroupCars: {
      id: number;
      wsaValue: {
        name: string;
        wsaSpecification: {
          title: string;
          wsa: string;
        };
      }[];
    }[];
  }[];
  public fromGroup = new UntypedFormGroup({});
  private firstCall = true;

  public opened = false;

  public searchValue = new BehaviorSubject<ArticlesSearch>({
    queryString: "",
    skip: 0,
    take: 50,
    WSA: [],
    selectedGroups: [],
  });
  public articles: any[];
  public articlesLength = 0;
  public api = environment.resource_api;

  public shopingArticles: any[];

  constructor(
    private articleService: ArticleService,
    private router: Router,
    public shoppingService: ShoppingService,
    public filterService: FilterService,
    public companyService: CompanyService,
    public userService: UserService,
    public spinnerService: SpinnerService,
    public dialog: MatDialog,
    public notify: NotifyService
  ) {
    this.brand = filterService.brand;
    this.type = filterService.type;

    if (this.shoppingService.order.shoppingBag.length > 0) {
      this.router.navigate([
        "/",
        "dashboard",
        "place-order",
        "overview",
        "ordered",
        false,
      ]);
    }

    if (!this.brand || !this.type) {
      this.router.navigate(["/", "dashboard", "place-order"]);
    }

    this.search(this.searchValue).subscribe((results) => {
      this.articles = results.articles;
      this.articles.forEach((x) => {
        x.isImageValid = true;
      });

      this.articlesLength =
        results.articles.length < 0 ? 0 : results.articles.length;

      const ids = [];
      for (const filter of this.filters) {
        const selectedValues = filter.columns.filter(
          (x) => x.searchValues[0].selected
        );
        for (const value of selectedValues) {
          ids.push(value.searchValues[0].id);
        }
      }

      this.companyService
        .getVerticalFilters(ids, this.type.id)
        .subscribe((res) => {
          this.fromGroup = new UntypedFormGroup({});
          const backupGroupFilter = JSON.parse(
            JSON.stringify(this.groupFilter)
          );
          const backupFilter = JSON.parse(JSON.stringify(this.filters));
          this.groupFilter = [];
          this.filters = [];

          this.wsaValues = res["data"]["groups"];
          this.userService.getCompanyInfo().subscribe((res: any) => {
            if (res.data.dbCompany.name.toLowerCase().includes("wensink")) {
              // this.wsaValues = [];

              // const groupIndex = this.wsaValues.findIndex(x => x.group === 'Kopschot');
              // this.wsaValues.splice(groupIndex, 1)
              this.wsaValues = this.wsaValues.filter(
                (x) =>
                  x.group != "Kopschot"
                // x.group == "Zijwand" ||
                // x.group == "Portier" ||
                // x.group == "Wielkast"
                // x.group == "Buitenbescherming"
              );
            }
            // this.wsaValues.find
            this.wsaValues.sort((a, b) => a.sort - b.sort);

            this.wsaValues.forEach((group) => {
              if (group.subgroups.length > 0) {
                const subgroups = [];

                group.subgroups.sort((a, b) => a.sort - b.sort);
                group.subgroups.forEach((subgroup) => {
                  if (subgroup.name.length > 0) {


                    // if (subgroup.name) {
                    //   // The following lines (if statements) are a temporary fix because we are removing GREY WOOD from the shop. 
                    //   // As a result the grey wood should be disabled for most customers but not some of them. 
                    //   const bannedSubGroupIndex = this.bannedSubGroups.findIndex(x => x === subgroup.name);
                    //   // console.log(bannedSubGroupIndex);
                    //   // if (bannedSubGroupIndex === -1) {
                    subgroups.push(subgroup.name);
                    //   // }
                    //   // if (!this.bannedSubGroups.find(x => x === subgroup.name) ||
                    //   //   this.allowedCompanies.some(x => x === this.userService.getCompany().company_prefix || this.userService.getCompany().company_prefix.toLowerCase().includes(x.toLowerCase()))) {
                    //   // }


                    // }

                    if (this.firstCall) {
                      this.addAndRemoveSubGroup(group.group, subgroup.name);
                    }
                  }
                });
                const subGroups = JSON.parse(JSON.stringify(subgroups));
                let selected = backupGroupFilter.find(
                  (x) => x.groupType === group.group
                );

                if (selected) {
                  selected = selected.selected;
                } else {
                  selected = [];
                }

                // Build group filter
                this.fromGroup.addControl(group.group, new UntypedFormControl([]));
                this.groupFilter.push({
                  groupType: group.group,
                  subGroup: subGroups,
                  image: group.image,
                  selected: selected,
                });

                this.addFilter(group, backupFilter);
              }
            });
            this.firstCall = false;
            this.sortFilters();
          });
        });
    });

    if (this.brand) {
      this.addAndRemoveBrandType("WSA_MERK", this.brand.name);
    }
    if (this.type) {
      this.addAndRemoveBrandType("WSA_TYPE", this.type.name);
    }
    this.getShoppingArticles();
  }

  private search(value: Observable<ArticlesSearch>) {
    return value.pipe(
      debounceTime(200),
      distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
      switchMap((searchValue) => {
        return this.articleService.getArticles(searchValue).pipe(map((x) => x));
      })
    );
  }

  public updateSearchQuery(newValue: any) {
    const copyValue = JSON.parse(JSON.stringify(this.searchValue.getValue()));
    copyValue.queryString = newValue.value;

    // UpdateSubject
    this.searchValue.next({ ...this.searchValue.value, ...copyValue });
  }

  public addAndRemoveBrandType(searchProperty: string, searchValue: string) {
    const copyValue: ArticlesSearch = JSON.parse(
      JSON.stringify(this.searchValue.getValue())
    );
    const filterIndex = copyValue.WSA.findIndex(
      (x: ArticleFilter) => x.searchProperty === searchProperty
    );
    // tslint:disable-next-line: no-shadowed-variable
    const filter = copyValue.WSA[filterIndex];

    if (filter === undefined || filter === null) {
      copyValue.WSA.push({
        searchProperty: searchProperty,
        searchValues: searchValue,
      });
    } else {
      copyValue.WSA.splice(filterIndex, 1);
    }

    // UpdateSubject
    this.searchValue.next({ ...this.searchValue.value, ...copyValue });
  }

  public addAndRemoveSubGroup(group: string, subgroup: string) {
    const copyValue: ArticlesSearch = JSON.parse(
      JSON.stringify(this.searchValue.getValue())
    );
    // tslint:disable-next-line: no-shadowed-variable
    const filter = copyValue.WSA.find(
      (x: ArticleFilter) => x.searchProperty === "groups"
    );

    // groups searchProperty does not exists
    if (filter === undefined || filter === null) {
      copyValue.WSA.push({
        searchProperty: "groups",
        searchValues: [{ group: group, subValues: [subgroup] }],
      });

      // groups searchProperty does exists
    } else {
      const groupSearchValue = filter.searchValues.find(
        (x) => x.group === group
      );

      // Group does not exists
      if (groupSearchValue === undefined) {
        filter.searchValues.push({ group: group, subValues: [subgroup] });
      } else {
        // Subgroup does not exists
        if (groupSearchValue.subValues.indexOf(subgroup) === -1) {
          groupSearchValue.subValues.push(subgroup);
        } else {
          groupSearchValue.subValues.splice(
            groupSearchValue.subValues.indexOf(subgroup),
            1
          );
        }

        if (groupSearchValue.subValues.length === 0) {
          filter.searchValues.splice(
            filter.searchValues.findIndex((x) => x.group === group),
            1
          );
        }
      }

      if (filter.searchValues.length === 0) {
        copyValue.WSA.splice(
          copyValue.WSA.findIndex(
            (x: ArticleFilter) => x.searchProperty === "groups"
          ),
          1
        );
      }
    }

    // UpdateSubject
    this.searchValue.next({ ...this.searchValue.value, ...copyValue });
  }

  public addAndRemoveFilter(wsa: string, value: string, title?: string) {
    const copyValue: ArticlesSearch = JSON.parse(
      JSON.stringify(this.searchValue.getValue())
    );
    // tslint:disable-next-line: no-shadowed-variable
    const filter = copyValue.WSA.find(
      (x: ArticleFilter) => x.searchProperty === wsa
    );

    // WsaKenmerk searchProperty does not exists
    if (filter === undefined || filter === null) {
      copyValue.WSA.push({ searchProperty: wsa, searchValues: [value] });
    } else {
      const wsaSearchValue = filter.searchValues.indexOf(value);

      // WsaValue does not exists
      if (wsaSearchValue === -1) {
        filter.searchValues.push(value);
      } else {
        // Subgroup does not exists
        filter.searchValues.splice(wsaSearchValue, 1);

        if (filter.searchValues.length === 0) {
          copyValue.WSA.splice(
            copyValue.WSA.findIndex(
              (x: ArticleFilter) => x.searchProperty === wsa
            ),
            1
          );
        }
      }
    }

    // UpdateSubject
    this.searchValue.next({ ...this.searchValue.value, ...copyValue });

    if (title) {
      // Keep UI up to date
      const foundFilter = this.filters
        .find((x) => x.title === title)
        .columns.find(
          (x) => x.searchValues[0].value === value && x.searchProperty === wsa
        );

      foundFilter.searchValues[0].selected =
        !foundFilter.searchValues[0].selected;
    }
  }

  public groupChanged(selectedSubGroup: string, groupType: string) {
    const group = this.groupFilter.find((x) => x.groupType === groupType);
    const selectedGroup = group.selected;
    const isSelected = selectedGroup.indexOf(selectedSubGroup) !== -1;

    // Remove everything from the query, because nothing is selected but somehting is going to
    if (this.groupFilter.filter((x) => x.selected.length > 0).length === 0) {
      this.addAndRemoveAllSubgroups();
    }

    // Add or remove item from selected group
    if (!isSelected) {
      selectedGroup.push(selectedSubGroup);
    } else {
      selectedGroup.splice(selectedGroup.indexOf(selectedSubGroup), 1);
    }

    // Select all items in group if the Alles item has been clicked, while it was not
    if (selectedSubGroup === "Alles" && !isSelected) {
      this.groupFilter
        .find((x) => x.groupType === groupType)
        .subGroup.forEach((subGroup) => {
          if (selectedGroup.indexOf(subGroup) !== -1) {
            return;
          }

          selectedGroup.push(subGroup);

          if (subGroup !== "Alles") {
            this.addAndRemoveSubGroup(groupType, subGroup);
          }
        });
      this.fromGroup.controls[groupType].setValue(selectedGroup);

      // Deselect all items in group if the Alles item has been clicked, while it was
    } else if (selectedSubGroup === "Alles" && isSelected) {
      this.groupFilter
        .find((x) => x.groupType === groupType)
        .subGroup.forEach((subGroup) => {
          if (selectedGroup.indexOf(subGroup) !== -1 && subGroup !== "Alles") {
            this.addAndRemoveSubGroup(groupType, subGroup);
          }
        });

      this.groupFilter.find((x) => x.groupType === groupType).selected = [];
      this.fromGroup.controls[groupType].setValue([]);
    } else {
      // Check if all subgroups except Alles is selected
      if (
        selectedGroup.length === group.subGroup.length - 1 &&
        selectedGroup.indexOf("Alles") === -1
      ) {
        selectedGroup.push("Alles");
        this.fromGroup.controls[groupType].setValue(selectedGroup);

        // Check if Alles selected is
      } else if (selectedGroup.indexOf("Alles") !== -1) {
        selectedGroup.splice(selectedGroup.indexOf("Alles"), 1);
        this.fromGroup.controls[groupType].setValue(selectedGroup);
      }

      this.addAndRemoveSubGroup(groupType, selectedSubGroup);
    }

    // Add everything to the query, because nothing is selected
    if (this.groupFilter.filter((x) => x.selected.length > 0).length === 0) {
      this.addAndRemoveAllSubgroups();
    }

    // Update visible filter list
    const copyFilter: Filter[] = JSON.parse(JSON.stringify(this.filters));
    const selectedGroups = this.groupFilter.filter(
      (x) => x.selected.length > 0
    );
    if (selectedGroups.length > 0) {
      // tslint:disable-next-line: no-shadowed-variable
      selectedGroups.forEach((group) => {
        const wsasForGroups = this.wsaValues.find(
          (x) => x.group === group.groupType
        );
        this.addFilter(wsasForGroups, copyFilter);
      });
    } else {
      // tslint:disable-next-line: no-shadowed-variable
      this.wsaValues.forEach((group) => {
        this.addFilter(group, copyFilter);
      });
    }

    this.sortFilters();
    this.removeUnusedFilters(copyFilter);
  }

  private addAndRemoveAllSubgroups() {
    this.groupFilter.forEach((group) => {
      group.subGroup.forEach((subgroup) => {
        if (subgroup === "Alles") {
          return;
        }

        this.addAndRemoveSubGroup(group.groupType, subgroup);
      });
    });
  }

  private removeUnusedFilters(copyFilter: Filter[]) {
    const filtersToRemove = [];

    for (const prevFilter of copyFilter) {
      const currentFilter = this.filters.find(
        (x) => x.title === prevFilter.title
      );

      if (currentFilter === undefined) {
        continue;
      }

      for (const prevValue of prevFilter.columns) {
        const title = prevValue.searchValues[0].title;
        if (
          !currentFilter.columns.find((x) => x.searchValues[0].title === title)
        ) {
          filtersToRemove.push(prevValue);
        }
      }
    }

    // tslint:disable-next-line: no-shadowed-variable
    filtersToRemove.forEach((filter) => {
      this.addAndRemoveFilter(
        filter.searchProperty,
        filter.searchValues[0].title
      );
    });
  }

  public getPrice() {
    let total = 0;
    if (this.articles) {
      this.shoppingService.shoppingCard.forEach((x) => {
        total +=
          x.qty *
          (this.getArticle(x.articleNumber)
            ? this.getArticle(x.articleNumber).brutoprijs
            : 0);
      });
    }
    return total.toFixed(2);
  }

  public addToShoppingCard(id: string, amount: number, code?: string) {
    const shoppingCard: { articleNumber: string; qty: number }[] =
      this.shoppingService.shoppingCard;

    if (shoppingCard.findIndex((x) => x.articleNumber === id) !== -1) {
      shoppingCard.find((x) => x.articleNumber === id).qty += amount;
    } else {
      shoppingCard.push({ articleNumber: id, qty: amount });
    }
    this.shoppingService.shoppingCard = shoppingCard;

    this.addAndRemoveGroupValue(code);
    this.getShoppingArticles();
  }

  public getShoppingArticles() {
    if (this.shoppingService.shoppingCard.length > 0) {
      // tslint:disable-next-line:max-line-length
      console.log(this.type);
      this.articleService
        .getArticlesFromCsv({
          articleNumbers: this.shoppingService.shoppingCard.map(
            (x) => x.articleNumber
          ),
          companyId: this.userService.getCompany().id,
          newPrice: this.type.newPrice,
        })
        .subscribe((x) => {
          this.shopingArticles = x.articles;
          this.shopingArticles.forEach((y) => {
            this.addAndRemoveGroupValue(y.Matchcode);
          });
        });
    }
  }

  getArticle(articleNumber: string) {
    if (this.shopingArticles) {
      return this.shopingArticles.find((x) => x.Nummer === articleNumber);
    }
    return null;
  }

  addQuantity(articleNumber: string) {
    const shoppingCard: { articleNumber: string; qty: number }[] =
      this.shoppingService.shoppingCard;
    shoppingCard.find((x) => x.articleNumber === articleNumber).qty += 1;
    this.shoppingService.shoppingCard = shoppingCard;
  }

  removeQuantity(articleNumber: string) {
    const shoppingCard: { articleNumber: string; qty: number }[] =
      this.shoppingService.shoppingCard;
    shoppingCard.find((x) => x.articleNumber === articleNumber).qty -= 1;
    this.shoppingService.shoppingCard = shoppingCard;
    if (this.shoppingService.shoppingCard.length === 0) {
      this.opened = false;
    }
  }

  removeFromShoppingCard(articleNumber: string) {
    const shoppingCard: { articleNumber: string; qty: number }[] =
      this.shoppingService.shoppingCard;
    shoppingCard.splice(
      shoppingCard.findIndex((x) => x.articleNumber === articleNumber),
      1
    );
    this.shoppingService.shoppingCard = shoppingCard;
    if (this.shoppingService.shoppingCard.length === 0) {
      this.opened = false;
    }
    this.addAndRemoveGroupValue(
      this.getArticle(articleNumber).Matchcode,
      false
    );
  }

  changeQuantiry(value: string, article: string) {
    const valueAsNumber = parseInt(value, 10);

    if (valueAsNumber > 0) {
      const shoppingCard: { articleNumber: string; qty: number }[] =
        this.shoppingService.shoppingCard;
      shoppingCard.find((x) => x.articleNumber === article).qty = valueAsNumber;
      this.shoppingService.shoppingCard = shoppingCard;
    } else {
      const shoppingCard: { articleNumber: string; qty: number }[] =
        this.shoppingService.shoppingCard;
      shoppingCard.find((x) => x.articleNumber === article).qty = 1;
      this.shoppingService.shoppingCard = shoppingCard;
    }
  }

  createOrderder() {
    const order = this.shoppingService.order;
    order.shoppingBag = Object.assign(this.shoppingService.shoppingCard);
    order.brand = this.brand;
    order.car_type = this.type;

    this.shoppingService.order = order;

    this.shoppingService.clear();
    this.router.navigate([
      "/",
      "dashboard",
      "place-order",
      "overview",
      "ordered",
      false,
    ]);
  }

  isSelected(groupType: string, subGroup: string) {
    return this.groupFilter
      .find((x) => x.groupType === groupType)
      .selected.indexOf(subGroup);
  }

  private addFilter(element, copyFilters?: Filter[]) {
    // tslint:disable-next-line: no-shadowed-variable
    element.wsaGroupCars.forEach((wsa) => {
      // tslint:disable-next-line: no-shadowed-variable
      if (!wsa.wsaValue) {
        return;
      }
      let filter = this.filters.find(
        (x) => x.title === wsa.wsaValue.wsaSpecification.title
      );
      if (!filter) {
        const newLength = this.filters.push({
          title: wsa.wsaValue.wsaSpecification.title,
          columns: [],
          order: wsa.wsaValue.wsaSpecification.sort,
        });

        filter = this.filters[newLength - 1];
      }

      const wsaValue = filter.columns.find(
        (x) => x.searchValues[0].title === wsa.wsaValue.name
      );
      if (!wsaValue) {
        const copyFilter: Filter = copyFilters
          ? copyFilters.find(
            (x) => x.title === wsa.wsaValue.wsaSpecification.title
          )
          : undefined;
        const selectedFilter =
          copyFilter && copyFilter.columns.length > 0
            ? copyFilter.columns.find(
              (x) => x.searchValues[0].title === wsa.wsaValue.name
            )
            : undefined;
        const selected = selectedFilter
          ? selectedFilter.searchValues[0].selected
          : false;
        filter.columns.push({
          searchProperty: wsa.wsaValue.wsaSpecification.wsa,
          searchValues: [
            {
              id: wsa.wsaValue.id,
              value: wsa.wsaValue.name,
              title: wsa.wsaValue.name,
              selected,
            },
          ],
        });
      }
    });
  }

  private sortFilters() {
    // tslint:disable-next-line: no-shadowed-variable
    this.filters.forEach((filter) => {
      filter.columns.sort(function (a, b) {
        if (a.searchValues[0].title < b.searchValues[0].title) {
          return -1;
        }
        if (a.searchValues[0].title > b.searchValues[0].title) {
          return 1;
        }
        return 0;
      });
    });

    this.filters.sort((a, b) => a.order - b.order);
  }

  public getImage(groupName: string) {
    for (const group of this.wsaValues) {
      for (const subgroup of group.subgroups) {
        if (subgroup.name === groupName) {
          return `${environment.resource_api}assets/${subgroup.name}.jpeg`;
        }
      }
    }
    return null;
  }

  public getArticleImage(number: string) {
    return `${environment.resource_api}assets/${number}.jpeg`;
  }

  navigateToBrand() {
    this.filterService.clearBrand();
    this.router.navigate(["/", "dashboard", "place-order"]);
  }

  navigateToType() {
    this.filterService.clearType();
    this.router.navigate(["/", "dashboard", "place-order"]);
  }

  setTypeValue(type: HTMLInputElement, number: number) {
    type.value = number.toString();
  }

  getTypeValue(type: HTMLInputElement): number {
    return parseInt(type.value, 10);
  }

  public addAndRemoveGroupValue(
    groupValue: string,
    isAddition: boolean = true
  ) {
    const copyValue: ArticlesSearch = JSON.parse(
      JSON.stringify(this.searchValue.getValue())
    );
    const selectedGroupIndex = copyValue.selectedGroups.findIndex(
      (x: { code: string; amount: 1 }) => x.code === groupValue
    );
    const selectedGroup = copyValue.selectedGroups[selectedGroupIndex];

    if ((selectedGroup === undefined || selectedGroup === null) && isAddition) {
      copyValue.selectedGroups.push({ code: groupValue, amount: 1 });
    } else if (isAddition) {
      copyValue.selectedGroups[selectedGroupIndex].amount += 1;
    } else {
      copyValue.selectedGroups.splice(selectedGroupIndex, 1);
    }

    // this.articles = this.articles.filter(x => x.Matchcode !== groupValue);

    // UpdateSubject
    this.searchValue.next({ ...this.searchValue.value, ...copyValue });
  }

  saveOrderder() {
    this.opened = true;
    const obj = {
      shoppingBag: this.shoppingService.shoppingCard,
      car_type: this.filterService.type,
      brand: this.filterService.brand,
    };
    const dialogRef = this.dialog.open(SaveOrderDialogComponent, {
      width: "400px",
      data: obj,
    });

    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
        this.notify.success("Offerte opgeslagen");
      }
    });
  }
  exportSelectionCSV() {
    const articleExportArray: {
      articleNumber: string;
      description: string;
      group: string;
      price: number;
      carType: string;
      carBrand: string;
      company: string;
    }[] = [];
    for (let article of this.articles) {
      articleExportArray.push({
        articleNumber: article.Nummer,
        description: article.KorteTekst,
        group: article.Groep,
        price: +article.brutoprijs.toFixed(2),
        carType: this.type.name,
        carBrand: this.brand.name,
        company: this.userService.getCompany().name,
      });
    }
    const header = Object.keys({
      articleNumber: "",
      description: "",
      group: "",
      price: "",
      carType: "",
      carBrand: "",
      company: "",
    });
    const replacer = (_, value) => (value === null ? "" : value); // specify how you want to handle null values here
    let csv = articleExportArray.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(";")
    );
    csv.unshift(header.join(";"));
    let csvArray = csv.join("\r\n");
    var blob = new Blob([csvArray], { type: "text/csv" });
    saveAs(blob, `${this.userService.getCompany().name.replace(/\s/g, "")}-${this.userService.user.getValue().firstname}-${new Date().getUTCDate()}`);
  }
  clearShoppingBag() {
    const copyValue: ArticlesSearch = JSON.parse(
      JSON.stringify(this.searchValue.getValue())
    );
    copyValue.selectedGroups = [];
    // UpdateSubject
    this.searchValue.next({ ...this.searchValue.value, ...copyValue });
  }
}
